// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"fb606e73","701":"fc6f7c37"}[chunkId] + ".chunk.css";
};